<template>
  <TableList
    v-rect-loading="loading"
    class="policy-tos-list"
    :title="$t($route.meta.titleI18nKey)"
    :listData="policyList"
    :tableColumns="tableColumns"
    :actionBtn="actionBtn"
    @create="handleClickAdd"
  >
    <template #status="{ row }">
      <el-switch v-model="row.enabled" @change="handleUpdatePolicy(row)"></el-switch>
    </template>
    <template #page-bottom>
      <DialogWrapper
        :show.sync="deleteDialog.show"
        :loading="deleteDialog.loading"
        :title="deleteDialog.title"
        @save="handleDelete"
      >
      </DialogWrapper>
    </template>
  </TableList>
</template>

<script>
import _ from 'lodash'
import { createI18nProperty } from '@/i18n'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import { mapActions } from 'vuex'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'

export default {
  components: {
    TableList,
    DialogWrapper
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.agreement',
      policyList: [],
      deleteDialog: {
        show: false,
        title: null,
        loading: false
      }
    }
  },
  computed: {
    privacy () {
      return this.$t(`${this.i18nPrefix}.label.PRIVACY`)
    },
    tableColumns () {
      return [
        {
          label: this.$t(`${this.i18nPrefix}.label.createTime`),
          dataKey: 'created_time'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.policyType`),
          dataKey: 'typeName'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.policyCreator`),
          dataKey: 'created_by'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.policyOpenStatus`),
          slotName: 'status',
          dataKey: 'status'
        }
      ]
    },
    actionBtn () {
      return {
        view: {
          show: true,
          onclick: this.handleViewBtnClick,
          labelI18nKey: `${this.i18nPrefix}.btn.viewPolicy`
        },
        edit: {
          show: (row) => !row.has_enabled,
          onclick: this.handleEditBtnClick
        }
      }
    }
  },
  created () {
    this.loadPolicyList()
  },
  methods: {
    ...mapActions('agreement', ['getSystemPolicyList', 'updateSystemPolicy', 'deleteSystemPolicy']),
    async loadPolicyList () {
      this.loading = true
      try {
        const resp = await this.getSystemPolicyList()
        if (resp) {
          this.policyList = _.forEach(resp, policy => {
            if (policy.type === 'PRIVACY') {
              createI18nProperty(policy, 'typeName', `${this.i18nPrefix}.label.PRIVACY`)
            } else if (policy.type === 'TOS') {
              createI18nProperty(policy, 'typeName', `${this.i18nPrefix}.label.TOS`)
            }
          })
        }
      } finally {
        this.loading = false
      }
    },
    async handleUpdatePolicy (row) {
      let hasSystemPrivacyPolicy = false
      let hasSystemTosPolicy = false
      _.forEach(this.policyList, policy => {
        if (policy.type === 'PRIVACY' && policy.enabled) {
          hasSystemPrivacyPolicy = true
        }
        if (policy.type === 'TOS' && policy.enabled) {
          hasSystemTosPolicy = true
        }
      })
      if (!hasSystemPrivacyPolicy || !hasSystemTosPolicy) {
        this.$message({
          message: this.$t(`${this.i18nPrefix}.message.notClosePolicy`),
          type: 'warning'
        })
        row.enabled = true
        return
      }
      const params = {
        policy_id: row.id,
        enabled: row.enabled,
        update_enabled: true
      }
      this.loading = true
      try {
        const resp = await this.updateSystemPolicy(params)
        if (resp) {
          this.$message({
            message: this.$t(`${this.i18nPrefix}.message.updateEnabled`),
            type: 'success'
          })
          _.forEach(this.policyList, (policy) => {
            if (policy.type === row.type) {
              policy.enabled = false
            }
          })
          row.enabled = true
          row.has_enabled = true
        }
      } finally {
        this.loading = false
      }
    },
    handleClickAdd () {
      this.$router.push({ path: '/v-admin/system-policy-management/add' })
    },
    handleViewBtnClick (row) {
      const params = new URLSearchParams({ policyId: row.id })
      window.open(`/recruiting/${row.type}?${params}`)
    },
    handleEditBtnClick (row) {
      this.$router.push({ path: `/v-admin/system-policy-management/edit/${row.id}`, query: { type: row.type } })
    },
    handleDeleteBtnClick (row) {
      this.deleteDialog.title = this.$t(`${this.i18nPrefix}.message.deleteOrNot`)
      this.deleteDialog.show = true
      this.deleteDialog.policyId = row.id
    },
    async handleDelete () {
      this.deleteDialog.loading = true
      const params = {
        policy_id: this.deleteDialog.policyId
      }
      try {
        const resp = await this.deleteSystemPolicy(params)
        if (resp) {
          this.loadPolicyList()
          this.$message.success(this.$t(`${this.i18nPrefix}.message.deleteSuccess`))
        } else {
          this.$message.warning(this.$t(`${this.i18nPrefix}.message.deleteFail`))
        }
        this.deleteDialog.show = false
      } finally {
        this.deleteDialog.loading = false
      }
    }
  },
  watch: {
    '$route' () {
      this.loadPolicyList()
    }
  }
}

</script>

<style lang='scss' scoped>
.policy-tos-list {

}
</style>
